import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Markdown } from '../markdown/markdown.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

export const Container: StyledComponent<'div'> = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Color.Error500};
  font-size: 14px;
  line-height: 18px;
  color: ${Color.White};
  width: 100%;
`;

export const StyledMenuPosition: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 18px;
  color: ${Color.White};
  font-weight: ${FontWeight.Regular};
`;

export const StyledMarkdown: StyledComponent<typeof Markdown> = styled(Markdown)`
  text-align: center;
`;
